import angular from 'angular';
import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import { Provider, useSelector } from 'react-redux';
import { store } from '../store/store';
import { NotificationTop } from '../components/notification-top';
import { DialogsContainer } from '../modules/dialogs';
import { Modal } from '../modules/extensions-framework/components/modal';
import { CallFrame } from '../modules/extensions-framework/components/call-frame';
import { MainMenuWrapper } from '../modules/extensions-framework/components/main-menu';
import { CallMenuWrapper } from '../modules/extensions-framework/components/call-menu';
import { CookiesProvider } from 'react-cookie';
import { localeService, selectors as coreSelectors } from '../modules/core';
import { defaultRichTextElements } from '../modules/core/components/with-providers/with-providers';
import growthbook from '../global/global.experiments';
export var ComponentTypes;
(function (ComponentTypes) {
    ComponentTypes["NOTIFICATION"] = "NOTIFICATION";
    ComponentTypes["MODAL"] = "MODAL";
    ComponentTypes["EXTENSION_CALL_MENU"] = "EXTENSION_CALL_MENU";
    ComponentTypes["EXTENSION_MAIN_MENU"] = "EXTENSION_MAIN_MENU";
    ComponentTypes["CALL_FRAME"] = "CALL_FRAME";
    ComponentTypes["DIALOGS_CONTAINER"] = "DIALOGS_CONTAINER";
})(ComponentTypes || (ComponentTypes = {}));
const InnerComponent = ({ Component }) => {
    const locale = useSelector(coreSelectors.getLocale);
    return (<CookiesProvider>
      <IntlProvider defaultRichTextElements={defaultRichTextElements} defaultLocale="en" messages={localeService.instance.messages} locale={locale || 'en'}>
        <GrowthBookProvider growthbook={growthbook}>
          <Component />
        </GrowthBookProvider>
      </IntlProvider>
    </CookiesProvider>);
};
const ComponentLoader = ({ type }) => {
    let LoadingComponent;
    switch (type) {
        case ComponentTypes.NOTIFICATION: {
            LoadingComponent = NotificationTop;
            break;
        }
        case ComponentTypes.MODAL: {
            LoadingComponent = Modal;
            break;
        }
        case ComponentTypes.EXTENSION_CALL_MENU: {
            LoadingComponent = CallMenuWrapper;
            break;
        }
        case ComponentTypes.EXTENSION_MAIN_MENU: {
            LoadingComponent = MainMenuWrapper;
            break;
        }
        case ComponentTypes.CALL_FRAME: {
            LoadingComponent = CallFrame;
            break;
        }
        case ComponentTypes.DIALOGS_CONTAINER: {
            LoadingComponent = DialogsContainer;
            break;
        }
        default: {
            console.error(`ComponentLoader: Type "${type}" not supported.`);
            return (<div style={{ padding: '10px', color: 'orange', fontSize: '12px' }}>
          Unsupported component type: {type}
        </div>);
        }
    }
    return (<Provider store={store}>
      <InnerComponent Component={LoadingComponent}/>
    </Provider>);
};
// This file intended to load react components to angular
// components will be wrapped in Provider and IntlProvider
export default angular
    .module('doxy.account.reactComponentLoader', [])
    .component('reactComponentLoader', {
    template: `<div></div>`,
    bindings: {
        type: '@',
    },
    controller: function ($element) {
        this.$onInit = function () {
            // Convert string binding to ComponentTypes enum value
            const componentType = this.type !== null && this.type !== undefined && this.type !== ''
                ? ComponentTypes[this.type]
                : undefined;
            if (componentType !== null && componentType !== undefined) {
                ReactDOM.render(React.createElement(ComponentLoader, { type: componentType }), $element[0]);
            }
            else {
                console.warn('ComponentLoader: Invalid or missing type:', this.type);
            }
        };
        this.$onDestroy = () => {
            ReactDOM.unmountComponentAtNode($element[0]);
        };
    },
}).name;
